import { render, staticRenderFns } from "./leader-transfer.vue?vue&type=template&id=783c5999&scoped=true"
import script from "./leader-transfer.vue?vue&type=script&lang=js"
export * from "./leader-transfer.vue?vue&type=script&lang=js"
import style0 from "./leader-transfer.vue?vue&type=style&index=0&id=783c5999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c5999",
  null
  
)

export default component.exports